import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { register_logger } from '@shared/utils/utils_logs';
import { ServiceLoggerNewRelicClient } from './new_relic/service_logger_new_relic_client';

export function init_loggers_remote() {
  if (!CONSTANTS__environment_client.VITE_SERVICE_NEW_RELIC_ENABLED_BOOLEAN) return;

  register_logger(new ServiceLoggerNewRelicClient());
}
